module.exports = __webpack_public_path__ + "static/scale-model-of-national-aquarium-in-baltimore-maryland-b444b82e98782866aea92e5e72bfc0ac.png";